import React, {Component} from 'react'
import {Link} from 'react-router-dom'

import Header from "../components/Header";
import Footer from '../components/Footer'

const Parts = () => (
    <div>
        <Header/>
        <div className="content partslist-page">
            <div className="container">
                <div className="title-partslist-page">
                    H1見出し見出し見出し：32px：#222222
                </div>
                <div className="img-three-dot">
                    <img src="images/three-dot.png" className="img-fluid"/>
                </div>
                <div className="description-item-parts">
                    通常のテキストが入ります。16px。#333333。通常のテキストが入ります。16px。#333333。通常のテキストが入ります。16px。#333333。通常のテキストが入ります。16px。#333333。通常のテキストが入ります。
                </div>
                <div className="h2-tag-parts">
                    <img src="images/icon_03.png" className="img-fluid"/>
                    <span>H2見出し見出し見出し：24px：＃867411</span>
                </div>
                <div className="description-item-parts">
                    通常のテキストが入ります。16px。#333333。通常のテキストが入ります。16px。#333333。通常のテキストが入ります。16px。#333333。通常のテキストが入ります。16px。#333333。通常のテキストが入ります。
                </div>
                <div className="h3-tag-parts">
                    <span>H3見出し見出し：22px：#867411</span>
                    <img src="images/border-h3.png" className="img-fluid"/>
                </div>
                <div className="description-item-parts">
                    通常のテキストが入ります。16px。#333333。通常のテキストが入ります。16px。#333333。通常のテキストが入ります。16px。#333333。通常のテキストが入ります。16px。#333333。通常のテキストが入ります。
                </div>
                <div className="h4-tag-parts">
                    <img src="images/icon_07.png" className="img-fluid"/>
                    <span>H4見出し見出し：18px：#222222</span>
                </div>
                <div className="description-item-parts">
                    通常のテキストが入ります。16px。#333333。通常のテキストが入ります。16px。#333333。通常のテキストが入ります。16px。#333333。通常のテキストが入ります。16px。#333333。通常のテキストが入ります。
                </div>
                <div className="h2-tag-parts">
                    <img src="images/icon_03.png" className="img-fluid"/>
                    <span>表組み</span>
                </div>
                <div className="table-parts-page pt-3">
                    <table className="table table-parts">
                        <tbody>
                        <tr>
                            <td className="td-custom-parts">項目項目項目</td>
                            <td>内容が入ります内容が入ります内容が入ります内容が入ります内容が入ります</td>
                        </tr>
                        <tr>
                            <td className="td-custom-parts">項目項目項目</td>
                            <td>内容が入ります内容が入ります内容が入ります内容が入ります内容が入ります</td>
                        </tr>
                        <tr>
                            <td className="td-custom-parts">項目項目項目</td>
                            <td>内容が入ります内容が入ります内容が入ります内容が入ります内容が入ります</td>
                        </tr>
                        <tr>
                            <td className="td-custom-parts">項目項目項目</td>
                            <td>２行パターン内容が入ります２行パターン２行パターン２行パターン２行パターン２行パターン２行パターン２行パターン２行パターン２行パターン２行パターン</td>
                        </tr>
                        </tbody>
                    </table>
                    <table className="table table-parts-mb">
                        <tbody>
                        <tr>
                            <td className="td-custom-parts">項目項目項目</td>
                        </tr>
                        <tr>
                            <td>内容が入ります内容が入ります内容が入ります内容が入ります内容が入ります</td>
                        </tr>
                        <tr>
                            <td className="td-custom-parts">項目項目項目</td>
                        </tr>
                        <tr>
                            <td>内容が入ります内容が入ります内容が入ります内容が入ります内容が入ります</td>
                        </tr>
                        <tr>
                            <td className="td-custom-parts">項目項目項目</td>
                        </tr>
                        <tr>
                            <td>内容が入ります内容が入ります内容が入ります内容が入ります内容が入ります</td>
                        </tr>
                        <tr>
                            <td className="td-custom-parts">項目項目項目</td>
                        </tr>
                        <tr>
                            <td>２行パターン内容が入ります２行パターン２行パターン２行パターン２行パターン２行パターン２行パターン２行パターン２行パターン２行パターン２行パターン</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div className="h2-tag-parts">
                    <img src="images/icon_03.png" className="img-fluid"/>
                    <span>お問い合わせフォーム</span>
                </div>
                <div className="table-parts-page pt-3">
                    <table className="table table-parts">
                        <tbody>
                        <tr>
                            <td className="td-custom-parts">
                                <div className="clearfix">
                                    <div className="float-left">
                                        テキストエリア
                                    </div>
                                    <div className="float-right">
                                        <img src="images/icon_08.png" className="img-fluid"/>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div className="td-right-parts">
                                    <div className="formgroup-parts-1">
                                        <div className="clearfix form-group">
                                            <div className="float-left">
                                                <div className="clearfix">
                                                    <div className="float-left text-control-1">
                                                        姓
                                                    </div>
                                                    <div className="float-right">
                                                        <input type="text" name="name_1"
                                                               className="form-control form-input-1"
                                                               placeholder="テキストテキスト"/>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="float-right">
                                                <div className="clearfix">
                                                    <div className="float-left text-control-1">
                                                        名
                                                    </div>
                                                    <div className="float-right">
                                                        <input type="text" name="name_2"
                                                               className="form-control form-input-1"
                                                               placeholder="テキストテキスト"/>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="clearfix form-group">
                                            <div className="float-left">
                                                <div className="clearfix">
                                                    <div className="float-left text-control-2">
                                                        セイ
                                                    </div>
                                                    <div className="float-right">
                                                        <input type="text" name="name_1"
                                                               className="form-control form-input-1"
                                                               placeholder="テキストテキスト"/>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="float-right">
                                                <div className="clearfix">
                                                    <div className="float-left text-control-2">
                                                        メイ
                                                    </div>
                                                    <div className="float-right">
                                                        <input type="text" name="name_2"
                                                               className="form-control form-input-1"
                                                               placeholder="テキストテキスト"/>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="clearfix form-group">
                                            <div className="float-left">
                                                <input type="text" name="name" className="form-control form-input-2"/>
                                            </div>
                                            <div className="float-left icon_mimus">
                                                -
                                            </div>
                                            <div className="float-left">
                                                <input type="text" name="name" className="form-control form-input-2"/>
                                            </div>
                                            <div className="float-left icon_mimus">
                                                -
                                            </div>
                                            <div className="float-left">
                                                <input type="text" name="name" className="form-control form-input-2"/>
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <input type="text" name="name" className="form-control form-input-3"
                                                   placeholder="テキストテキスト"/>
                                            <span className="note-formgroup-3">※フォーム注釈フォーム注釈フォーム注釈フォーム注釈</span>
                                        </div>
                                    </div>
                                    <div className="textarea">
                                        <textarea className="form-control" rows="6" placeholder="テキストテキスト"></textarea>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td className="td-custom-parts">
                                <div className="clearfix">
                                    <div className="float-left">
                                        プルダウン
                                    </div>
                                    <div className="float-right">
                                        <img src="images/icon_08.png" className="img-fluid"/>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <select className="form-control select-form-4" name="name">
                                    <option>選択してください</option>
                                    <option>選択してください</option>
                                </select>
                            </td>
                        </tr>
                        <tr>
                            <td className="td-custom-parts">
                                <div className="clearfix">
                                    <div className="float-left">
                                        ラジオボタン
                                    </div>
                                    <div className="float-right">
                                        <img src="images/icon_08.png" className="img-fluid"/>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div className="clearfix ml-2">
                                    <div className="float-left">
                                        <label className="label-radio mr-4">
                                            <input checked="checked" name="payment_method" type="radio"
                                                   value="Bitcoin"/>
                                            <span className="checkmark"></span>
                                            選択してください
                                        </label>
                                    </div>
                                    <div className="float-left ml-4 form-check">
                                        <label className="label-radio">
                                            <input checked="checked" name="payment_method" type="radio"
                                                   value="Bitcoin"/>
                                            <span className="checkmark"></span>
                                            選択してください
                                        </label>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td className="td-custom-parts">
                                <div className="clearfix">
                                    <div className="float-left">
                                        エラー体裁
                                    </div>
                                    <div className="float-right">
                                        <img src="images/icon_08.png" className="img-fluid"/>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div className="ml-2">
                                    <div className="text-danger-td-parts">
                                        エラー文言が入りますエラー文言が入ります(#e53a3a)
                                    </div>
                                    <div className="form-group-m">
                                        <input type="text" name="name" className="form-control form-input-4"
                                               placeholder="テキストテキスト"/>
                                        <span className="note-formgroup-3">※フォーム注釈フォーム注釈フォーム注釈フォーム注釈</span>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <table className="table table-parts-mb">
                        <tbody>
                        <tr>
                            <td className="td-custom-parts-mb">
                                <div className="clearfix">
                                    <div className="float-left">
                                        テキストエリア
                                    </div>
                                    <div className="float-right">
                                        <img src="images/icon_08.png" className="img-fluid"/>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div className="clearfix">
                                    <div className="float-left text-control-mb-1">
                                        姓
                                    </div>
                                    <div className="float-right form-input-mb-1">
                                        <input type="text" name="name_1" className="form-control" placeholder="テキストテキスト"/>
                                    </div>
                                </div>
                                <div className="clearfix mt-3">
                                    <div className="float-left text-control-mb-1">
                                        名
                                    </div>
                                    <div className="float-right form-input-mb-1">
                                        <input type="text" name="name_2" className="form-control" placeholder="テキストテキスト"/>
                                    </div>
                                </div>
                                <div className="clearfix mt-3">
                                    <div className="float-left text-control-mb-1">
                                        セイ
                                    </div>
                                    <div className="float-right form-input-mb-1">
                                        <input type="text" name="name_1" className="form-control" placeholder="テキストテキスト"/>
                                    </div>
                                </div>
                                <div className="clearfix mt-3">
                                    <div className="float-left text-control-mb-1">
                                        メイ
                                    </div>
                                    <div className="float-right form-input-mb-1">
                                        <input type="text" name="name_2" className="form-control" placeholder="テキストテキスト"/>
                                    </div>
                                </div>
                                <div className="clearfix form-group mt-3">
                                    <div className="float-left form-input-mb-2">
                                        <input type="text" name="name" className="form-control"/>
                                    </div>
                                    <div className="float-left icon_mimus_mb">
                                        -
                                    </div>
                                    <div className="float-left form-input-mb-2">
                                        <input type="text" name="name" className="form-control"/>
                                    </div>
                                    <div className="float-left icon_mimus_mb">
                                        -
                                    </div>
                                    <div className="float-left form-input-mb-2">
                                        <input type="text" name="name" className="form-control"/>
                                    </div>
                                </div>
                                <div className="form-group formgroup-mb-parts-3 mt-3">
                                    <input type="text" name="name" className="form-control" placeholder="テキストテキスト"/>
                                    <span className="note-formgroup-3">※フォーム注釈フォーム注釈フォーム注釈フォーム注釈</span>
                                </div>
                                <div className="textarea">
                                    <textarea className="form-control" rows="6" placeholder="テキストテキスト"></textarea>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td className="td-custom-parts">
                                <div className="clearfix">
                                    <div className="float-left">
                                        プルダウン
                                    </div>
                                    <div className="float-right">
                                        <img src="images/icon_08.png" className="img-fluid"/>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <select className="form-control select-form-mb-4" name="name">
                                    <option>選択してください</option>
                                    <option>選択してください</option>
                                </select>
                            </td>
                        </tr>
                        <tr>
                            <td className="td-custom-parts">
                                <div className="clearfix">
                                    <div className="float-left">
                                        ラジオボタン
                                    </div>
                                    <div className="float-right">
                                        <img src="images/icon_08.png" className="img-fluid"/>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div className="form-check">
                                    <label className="label-radio mr-4">
                                        <input checked="checked" name="payment_method" type="radio" value="Bitcoin"/>
                                        <span className="checkmark"></span>
                                        選択してください
                                    </label>
                                </div>
                                <div className="form-check">
                                    <label className="label-radio">
                                        <input checked="checked" name="payment_method" type="radio" value="Bitcoin"/>
                                        <span className="checkmark"></span>
                                        選択してください
                                    </label>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td className="td-custom-parts">
                                <div className="clearfix">
                                    <div className="float-left">
                                        エラー体裁
                                    </div>
                                    <div className="float-right">
                                        <img src="images/icon_08.png" className="img-fluid"/>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div className="ml-2">
                                    <div className="text-danger-td-parts">
                                        エラー文言が入ります(#e53a3a)
                                    </div>
                                    <div className="form-group-m">
                                        <input type="text" name="name" className="form-control form-input-mb-4"
                                               placeholder="テキストテキスト"/>
                                        <span className="note-formgroup-3">※フォーム注釈フォーム注釈フォーム注釈フォーム注釈</span>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div className="div-btn-confirm-partslist">
                    <a href="#">
                        <div className="button-confirm-partslist">
                            確認ページへ
                        </div>
                    </a>
                </div>
                <div className="button-back-and-send">
                    <div className="row">
                        <div className="col-md-6 full-width-column">
                            <div className="div-btn-back-partslist">
                                <a href="#">
                                    <div className="btn-back-partslist">
                                        戻る
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div className="col-md-6 full-width-column">
                            <div className="div-btn-send-partslist">
                                <a href="#">
                                    <div className="btn-send-partslist">
                                        送信する
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Footer/>
    </div>
)

export default Parts